// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderedList_wrapper__OmOET","item":"OrderedList_item__8I01d"};